import { render } from "./YearSelector.vue?vue&type=template&id=46c6f83a&scoped=true"
import script from "./YearSelector.vue?vue&type=script&lang=js"
export * from "./YearSelector.vue?vue&type=script&lang=js"

import "./YearSelector.vue?vue&type=style&index=0&id=46c6f83a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c6f83a"]])

export default __exports__